export { default } from '@material-ui/core/Toolbar';

export type ToolbarProps = import('@material-ui/core/Toolbar').ToolbarProps;
